import { render } from "./dialog.vue?vue&type=template&id=3d062321&scoped=true"
import script from "./dialog.vue?vue&type=script&lang=js"
export * from "./dialog.vue?vue&type=script&lang=js"

import "./dialog.vue?vue&type=style&index=0&id=3d062321&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src734602948/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d062321"]])

export default __exports__